import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BulkDraftProceedModalUI from './BulkDraftProceedModalUI.js'

class BulkDraftProceedModalSF extends Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.fileInput = React.createRef()

    this.state = {
      successMsg: null,
      errorList: [],
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <BulkDraftProceedModalUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        submitted={this.state.submitted}
        // modes
        uploadMode={this.props.uploadMode}
        // event handlers
        onSubmit={this.handleSubmit}
        onCancelClick={this.props.onCancelClick}
        // file input
        fileInput={this.fileInput}
      />
    )
  }

componentDidUpdate(prevProps) {
  if (this.props.uploadMode && !prevProps.uploadMode) {
    this.setState({
      successMsg: null,
      errorList: [],
      submitted: false
    })
    
    if (this.fileInput.current) {
      this.fileInput.current.value = ''
    }
  }
}

  setErrorList = (errorList) => {
    this.setState({ errorList })
  }

  handleSubmit(event) {
    event.preventDefault()
    
    // Check if already submitting
    if (this.state.submitted) {
      return
    }

    if (!this.fileInput.current.files[0]) {
      this.setState({
        errorList: ['Please select a file to upload'],
        submitted: false
      })
      return
    }

    const file = this.fileInput.current.files[0]
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel' // .xls
    ]
    
    // Also check file extensions as backup ->
    const fileName = file.name.toLowerCase()
    const allowedExtensions = ['.xlsx', '.xls']
    const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext))
    
    if (!allowedTypes.includes(file.type) && !hasValidExtension) {
      this.setState({
        errorList: ['Please select only Excel files (.xlsx or .xls)'],
        submitted: false
      })
      return
    }

    console.log(`Selected file - ${file.name}, Type: ${file.type}, Size: ${file.size}`)

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    this.uploadFile(file)
  }

  uploadFile = (file) => {
    console.log('Uploading file:', file.name, 'Size:', file.size, 'Type:', file.type)
    
    RestApiUtils.postFile(
      this.props.context,
      `/api/su/loan/${this.props.loanId}/draftProceeds/bulkUpload`,
      this.onUploadCallback,
      file,
      'file'
    )
  }

  onUploadCallback = (json) => {
    console.log('Upload callback received:', json)
    
    this.setState({ 
      submitted: false,
      successMsg: json.success || null
    })
    
    if (json && json.errorList) {
      this.setErrorList(json.errorList.map(error => error.message))
    } else {
      this.setErrorList([])
    }
    
    if (!json.errorList || json.errorList.length === 0) {
      setTimeout(() => {
        this.props.onRefreshClick()
        this.props.onCancelClick()
      }, 1000)
    }
  }
}

export default withRouter(BulkDraftProceedModalSF)
